import React from 'react';
import MadeBy from '../MadeBy';
import '../../../styles/scss/footer.scss';

const Footer = () => {
    return (
        <div className="footer">
            <MadeBy />
        </div>
    );
}

export default Footer;